import { render } from "./CustomerTypes.vue?vue&type=template&id=0966e316&scoped=true"
import script from "./CustomerTypes.vue?vue&type=script&lang=js"
export * from "./CustomerTypes.vue?vue&type=script&lang=js"

import "./CustomerTypes.vue?vue&type=style&index=0&id=0966e316&scoped=true&lang=css"

import exportComponent from "/workspace/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0966e316"]])

export default __exports__